import { render, staticRenderFns } from "./AddWholesalerComponent.vue?vue&type=template&id=8796e2d8&"
import script from "./AddWholesalerComponent.vue?vue&type=script&lang=js&"
export * from "./AddWholesalerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports